module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"label_inn":"ИНН","input_inn":"ИНН"}}')
  delete Component.options._Ctor
}
